import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.sales-kpi-month',
    method: 'get',
    params,
  })
}

export const listAll = (params?: any) => {
  return axiosService({
    url: '/api.sales-kpi-month/all',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.sales-kpi-month/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.sales-kpi-month/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.sales-kpi-month/${id}`,
    method: 'put',
    data,
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.sales-kpi-month/${id}/reject`,
    method: 'put',
    data,
  })
}

export const approve = (id: number, data: any = {}) => {
  return axiosService({
    url: `/api.sales-kpi-month/${id}/approve`,
    method: 'put',
    data,
  })
}

export const apply = (id: number) => {
  return axiosService({
    url: `/api.sales-kpi-month/${id}/apply`,
    method: 'put',
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.sales-kpi-month/${id}/remake`,
    method: 'put',
    data,
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.sales-kpi-month/${id}`,
    method: 'delete',
  })
}
